import React from 'react';
import {LINK_IMG,URl_PAGEHOME} from '../../../utils/config';

export default class ListExam extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            numberShow:2,
            title:'Xem thêm',
            data:this.props.data
        };
    }

    componentWillReceiveProps(nextProps){
        if(this.props.data != nextProps.data){
            this.setState({
                data: nextProps.data
            })
        }
    }

    render(){
        const {data}=this.state;
        return(
            <div className="listSubject">
                <h3 className="titleNews">Các bài có liên quan</h3>
                {
                    data.map((value,index) => {
                        return(
                            <a key={index} href={URl_PAGEHOME+"de-thi-"+value.alias+"-exam"+value.id+'.html'} className="n-exercise">
                                <div className="n-content-exercise">
                                    <img className="fl" src={LINK_IMG+value.thumbnail} />
                                    <span>{value.title}</span>
                                    <p>{value.introtext}</p>
                                </div>
                                <span className="btn-show">Xem chi tiết</span>
                            </a>
                            )
                    })
                }
            </div>
        )
    }
}
